const breakpointL = 1300;

export { breakpointL };
